export default __webpack_public_path__ + "static/media/Storage.158ded9e.mp4";